import { computed } from 'vue'
import { useRoute } from 'vue-router'

/**
 * Composable for checking signing-related feature flags.
 * Uses ENV-based allowlists (same pattern as backend).
 *
 * Allowlist format:
 * - 'all' = enabled for all groups
 * - 'acme,venture-360,demo' = enabled for specific subdomains
 * - '' (blank) = disabled for all groups
 */
export function useSigningFeatureFlags() {
  const route = useRoute()

  const slug = computed(() => route.params.slug as string)

  const isInAllowlist = (envVar: string | undefined): boolean => {
    if (!envVar || envVar.trim() === '') return false
    if (envVar === 'all') return true
    if (!slug.value) return false

    const allowlist = envVar.split(',').map((s) => s.trim())
    return allowlist.includes(slug.value)
  }

  const isSpvAutoSigningEnabled = computed(() =>
    isInAllowlist(import.meta.env.VITE_FF_SIGNING_SPV_AUTOMATED_SIGNATURE_REQUEST_ALLOWLIST),
  )

  const isSpvGlobalTemplatesEnabled = computed(() =>
    isInAllowlist(import.meta.env.VITE_FF_SIGNING_SPV_GLOBAL_TEMPLATES_ALLOWLIST),
  )

  return {
    isSpvAutoSigningEnabled,
    isSpvGlobalTemplatesEnabled,
  }
}
